// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {"366": "bd6a3a9f","769": "cd6654aa",}[chunkId] + ".css"
}